import React from 'react'

import facebookImage from '../../../../../public/static/images/svg/facebookLogo.svg'

const FacebookLogo = (props) => {
  return (
    <a href="https://www.facebook.com/thewinitapp/" target="_blank" rel="noopener noreferrer">
      <img src={facebookImage} alt="facebook logo" />
    </a>
  )
}

export default FacebookLogo